let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2HI26")).then(() => parcelRequire('13hJH'));